import React from 'react';
import { Link } from 'react-router-dom';
import MarketingShell from '../marketing/MarketingShell';
import PageMeta from '../seo/PageMeta';

const NotFoundPage = () => (
  <MarketingShell title="Page not found">
    <PageMeta title="Page not found" description="This page does not exist on QnaRead." noindex nofollow />
    <p className="marketing-lead">This page does not exist or was moved.</p>
    <div className="marketing-hero-actions">
      <Link to="/" className="marketing-btn marketing-btn-primary">Home</Link>
      <Link to="/login" className="marketing-btn marketing-btn-secondary">Sign in</Link>
    </div>
  </MarketingShell>
);

export default NotFoundPage;
